import React from "react";

function Index() {
  return (
    <section className="container">
      <div className="error">Page Not Found. 404!!!</div>
    </section>
  );
}

export default Index;
